import { withStyles } from '@material-ui/styles';
import HubLockLog from './HubLockLog';
import styles from './styles';

export default withStyles(styles)(HubLockLog);
